import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Switch, Text, tokens } from '@hotjar/hotsauce';
import { trackClick } from '@hotjar/tracking';

import type { TrackableSite } from '../../constants-types/ExternalDependencyTypes';
import { EVENT_NAMES } from '../../constants-types/TrackEventNames';
import { EVENT_UI_POSITIONS } from '../../constants-types/TrackEventUIPositions';
import { getTrackGroupDataAndTriggeredOnState } from '../../utils/trackingUtils';
import { HEATMAP_DEVICE_TYPES } from '../../constants-types/HeatmapDeviceTypes';

interface TopClicksWidgetProps {
  currentSite?: TrackableSite;
  device: HeatmapDeviceTypes;
  isTopClicksWidgetActive: boolean;
  onTopClicksWidgetToggle: (isActive: boolean) => void;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${tokens.spacer.x2};
`;

const TopClicksWidgetToggle = styled(Switch)`
  margin-bottom: 0;
`;

const CLASS_NAME = 'jh-hm-sp-top-clicks';

export const TopClicksWidget = ({
  currentSite,
  device,
  isTopClicksWidgetActive,
  onTopClicksWidgetToggle,
}: TopClicksWidgetProps): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  const clicksOrTaps =
    device === HEATMAP_DEVICE_TYPES.DESKTOP
      ? t('smart-panel.top-clicks')
      : t('smart-panel.top-taps');

  const handleTopClicksWidgetToggle = (isActive: boolean) => {
    if (currentSite !== undefined && !isActive) {
      trackClick({
        name: EVENT_NAMES.TOP_CLICKS_WIDGET,
        uiPosition: EVENT_UI_POSITIONS.SMART_PANEL,
        ...getTrackGroupDataAndTriggeredOnState(currentSite),
      });
    }
    onTopClicksWidgetToggle(isActive);
  };

  return (
    <Container className={CLASS_NAME}>
      <Text textType="caption">{clicksOrTaps}</Text>
      <TopClicksWidgetToggle
        isChecked={isTopClicksWidgetActive}
        onChange={handleTopClicksWidgetToggle}
      />
    </Container>
  );
};
